import logoUrl from "@/assets/te-connectivity-logo.png";

/**
 * TE Connectivity logo — the official mark supplied by the customer
 * (src/assets/te-connectivity-logo.png; white "TE / connectivity" on brand orange).
 */
export function TeLogo({ height = 30, title = "TE Connectivity" }: { height?: number; title?: string }) {
  return <img src={logoUrl} alt={title} title={title} style={{ height, display: "block", flexShrink: 0 }} />;
}
